import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import LocationEditForm from '~/containers/locationEdit/locationEdit';
import LocationArchive from '~/containers/locationArchive/locationArchive';

export class LocationEditPage extends Component {
  state = {
    location: null
  };

  onReceiveLocation = ({ location }) => {
    this.setState({
      location
    });
  };

  render() {
    const locationId = this.props.match.params.locationId;
    const { location } = this.state;

    const editButton = (
      <div className="flex">
        <LocationArchive className="mr4" loc={location} />
        <Link to={`/settings/locations/${locationId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar
          back={`/settings/locations/${locationId}`}
          backText="Location"
          title={location ? location.name : '...'}
          button={editButton}
        />
        <LocationEditForm onCompleted={this.onReceiveLocation} id={locationId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(LocationEditPage));



// WEBPACK FOOTER //
// ./src/pages/locationEdit/locationEdit.jsx